<template>
    <div>
        <v-row>
            <v-col cols="12" lg="4">
                <button
                    class="button back-to-list"
                    style="height: 36px"
                    @click="$root.goTo($root.route('patients.index'))"
                >
                    <v-icon>mdi-arrow-left</v-icon>
                    <span class="text">Back To List</span>
                </button>
            </v-col>
            <v-col cols="12" lg="8">
                <div class="latest-blood-results-wrapper-actions">
                    <div class="latest-blood-results-wrapper-actions-buttons">
                        <v-btn
                            v-if="can('patients.generate-labels')"
                            color="primary"
                            text
                            small
                            rounded
                            @click="generateLabel()"
                        >
                            {{ t('patients::button.generate_label') }}
                        </v-btn>
                        <v-btn
                            v-if="can('api.v1.patients.blood-results.store')"
                            color="primary"
                            class="ml-4"
                            small
                            rounded
                            @click="newBloodResult()"
                        >
                            {{ t('patients::button.create.blood_result') }}
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <div :class="'latest-blood-results-wrapper px-4 py-2 mt-4 ' + bannerColor">
            <div class="latest-blood-results-header">
                <v-row class="m-0">
                    <v-col cols="12" lg="8" class="py-2 pl-0">
                        <div v-if="!!patient.last_blood_sample_color" class="copy">
                            <div
                                :class="
                                    'latest-blood-results-color latest-blood-results-color-' +
                                    patient.last_blood_sample_color +
                                    (patient.is_abnormal_last_sample ? ' latest-blood-results-color-abnormal' : '')
                                "
                            >
                                <v-icon left small>icon icon-blood-result</v-icon>
                                <p class="latest-blood-results-color-type">
                                    {{
                                        patient.is_abnormal_last_sample ? 'Repeat' : patient.last_blood_sample_color
                                    }}&nbsp;
                                </p>
                                <p
                                    v-if="
                                        !patient.is_abnormal_last_sample &&
                                        patient.validity_date &&
                                        patient.color !== 'red'
                                    "
                                    class="latest-blood-results-color-validity_date"
                                >
                                    {{ t('patients::header.valid_until') }}:
                                    {{ moment(patient.validity_date).format($root.dateFormat) }}
                                </p>
                                <p
                                    v-if="!patient.is_abnormal_last_sample && patient.last_blood_sample_color === 'red'"
                                    class="latest-blood-results-color-validity_date"
                                >
                                    &nbsp;-&nbsp;&nbsp;{{ t('patients::header.very_low_blood_result') }}
                                </p>
                                <p v-if="patient.is_abnormal_last_sample" class="latest-blood-results-color-abnormal">
                                    &nbsp;-&nbsp;&nbsp;{{ t('patients::status-blood-result-abnormal') }}
                                </p>
                            </div>
                        </div>
                        <div class="latest-blood-results-color-meta">
                            <p v-if="!dispensingPermitted">{{ t('patients::header.dispensing_not_permitted') }}</p>
                            <p v-if="patient.color === 'red'">
                                {{ t('patients::header.do_not_dispense') }}
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="py-2 text-md-end"
                        ><span class="latest-blood-results-header-id"
                            >{{ t('patients::header.id') }}: {{ patient.dms_id }}</span
                        >
                        <br />
                        <span class="latest-blood-results-header-dob"
                            >{{ t('patients::header.dob') }}:
                            {{ moment(patient.birth_date).format($root.dateFormat) }}</span
                        >
                    </v-col>
                </v-row>
                <v-row class="m-0">
                    <v-col cols="auto" class="p-0 latest-blood-patient-name-col">
                        <div class="latest-blood-patient-name">
                            <h1 class="latest-blood-results-header-name">{{ patient.name }}</h1>
                            <div v-if="healthStatus(patient)" class="grid-status colored">
                                <span>
                                    {{ healthStatus(patient) }}
                                </span>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="auto" class="meta p-0">
                        <v-col
                            v-for="(bloodResultDetail, index) in bloodResultsDetails"
                            :key="bloodResultDetail.text"
                            cols="auto"
                            :class="`latest-blood-col ${
                                bloodResultDetail.type && bloodResultDetail.detail ? bloodResultDetail.type : ''
                            }`"
                        >
                            <div class="latest-blood-results-detail-wrap">
                                <v-divider v-if="index !== 0" vertical class="m-0"></v-divider>
                                <div class="latest-blood-results-detail">
                                    <p class="latest-blood-results-detail-text">{{ bloodResultDetail.text }}</p>
                                    <p v-if="!bloodResultDetail.status" class="latest-blood-results-detail-detail">
                                        {{ bloodResultDetail.detail }}
                                    </p>
                                    <template v-if="bloodResultDetail.status">
                                        <p
                                            class="latest-blood-results-detail-detail"
                                            v-text="
                                                bloodResultDetail.detail
                                                    ? t('patients::prohibited.true')
                                                    : t('patients::prohibited.false')
                                            "
                                        ></p>
                                    </template>
                                </div>
                            </div>
                        </v-col>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        patient() {
            return this.$store.state.patients.patient;
        },
        dispensingPermitted() {
            return _.has(this.$store.state.patients.patient, 'dispensing.permitted')
                ? this.$store.state.patients.patient.dispensing.permitted
                : false;
        },
        bannerColor() {
            return this.patient.is_abnormal_last_sample ? 'blood-none' : 'blood-' + this.patient.banner_color;
        },
        id() {
            return this.$store.state.patients.patient.id;
        },
        bloodResultsDetails() {
            let firstDate = this.patient.first_blood_sample_date
                ? moment(this.patient.first_blood_sample_date).format(this.$root.dateFormat)
                : t('default::label.na');
            let lastDate = this.patient.last_blood_sample_date
                ? moment(this.patient.last_blood_sample_date).format(this.$root.dateFormat)
                : t('default::label.na');
            let nextDate = this.patient.dispensing.next_due_date
                ? moment(this.patient.dispensing.next_due_date).format(this.$root.dateFormat)
                : t('default::label.na');

            let frequency = this.patient.blood_testing_frequency
                ? t('patients::dispensing.form.frequency_items.' + this.patient.blood_testing_frequency)
                : t('default::label.na');

            return [
                {
                    icon: 'icon-blood-sample',
                    type: 'colored',
                    text: t('patients::header.overdue'),
                    detail: this.patient.overdue,
                    status: true,
                },
                {
                    icon: 'icon-blood-sample',
                    type: 'colored',
                    text: t('patients::header.prohibited'),
                    detail: this.patient.prohibited,
                    status: true,
                },
                {
                    icon: 'icon-blood-sample',
                    text: t('patients::header.max_dispensing'),
                    detail: this.patient.max_dispensing,
                    status: true,
                },
                {
                    icon: 'icon-blood-sample',
                    text: t('patients::header.treatment_break'),
                    detail: this.patient.has_treatment_break,
                    status: true,
                },
                { icon: 'icon-blood-sample', text: t('patients::header.first_blood_sample'), detail: firstDate },
                { icon: 'icon-last-blood-sample', text: t('patients::header.last_blood_sample'), detail: lastDate },
                {
                    icon: 'icon-frequency-of-blood-testing',
                    text: t('patients::header.frequency_of_blood_testing'),
                    detail: frequency,
                },
                { icon: 'icon-next-test-due', text: t('patients::header.next_test_due'), detail: nextDate },
            ];
        },
    },
    methods: {
        newBloodResult() {
            this.$store.dispatch('patients/newBloodResult');
        },
        generatePdf() {
            return this.$root.notify('warning', '#TODO');
        },
        generateLabel() {
            this.$root.goTo(this.$root.route('patients.generate-label', { patient: this.id }));
            this.$root.notify('info', t('patients::notification.success'), t('patients::notification.generate_label'));
        },
        healthStatus(item) {
            if (_.includes(item.health_status, 'na')) {
                return false;
            }
            if (item && item.health_status) {
                return _.map(item.health_status, (status) => {
                    return t('patients::health_status.' + status);
                }).join(', ');
            }
            return false;
        },
    },
};
</script>

<style scoped>
.latest-blood-results-color-abnormal {
    color: #75797c;
}
</style>
